import { render, staticRenderFns } from "./ReviewScreen.vue?vue&type=template&id=1f9c3c49&scoped=true&"
import script from "./ReviewScreen.vue?vue&type=script&lang=js&"
export * from "./ReviewScreen.vue?vue&type=script&lang=js&"
import style0 from "./ReviewScreen.vue?vue&type=style&index=0&id=1f9c3c49&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9c3c49",
  null
  
)

export default component.exports